import { PostDisplay } from '$types';
import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css']
})

export class MediaComponent {

  @Input() post!: PostDisplay;
  selectedIndex: number = 0;

  getImageClassname(index: string): string {
    return parseInt(index) == this.selectedIndex ? 'selected' : 'hidden'
  }

  plusSlides(arg0: number): void {
    if (arg0 < 0) {
      this.selectedIndex = this.selectedIndex - 1
    } else {
      this.selectedIndex = this.selectedIndex + 1
    }

    if (this.selectedIndex < 0) {
      this.selectedIndex = this.post.photos.length - 1
    } else if (this.selectedIndex > this.post.photos.length - 1) {
      this.selectedIndex = 0
    }
  }
}
